let scrollBarSize: number | null = null;

const useScrollbarSize = () => {
  if (scrollBarSize === null) {
    // thanks to https://davidwalsh.name/detect-scrollbar-width
    const scrollDiv = document.createElement('div');
    scrollDiv.setAttribute(
      'style',
      'width: 100px; height: 100px; overflow: scroll; position:absolute; top:-9999px;'
    );
    document.body.appendChild(scrollDiv);
    scrollBarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
  }
  return scrollBarSize;
};

export default useScrollbarSize;
